export const ANSWER_SET_VALUE = "ANSWER_SET_VALUE";
export const ANSWER_REMOVE_VALUE = "ANSWER_REMOVE_VALUE";
export const ANSWER_START_RESPONSE = "ANSWER_START_RESPONSE";
export const ANSWER_SAVE_RESPONSE = "ANSWER_SAVE_RESPONSE";
export const ANSWER_SAVE_RESPONSE_FULFILLED = "ANSWER_SAVE_RESPONSE_FULFILLED";
export const ANSWER_FINISH_RESPONSE = "ANSWER_FINISH_RESPONSE";
export const ANSWER_START_RESPONSE_FULFILLED = "ANSWER_START_RESPONSE_FULFILLED";
export const ANSWER_REMOVE = "ANSWER_REMOVE";